import { useLocation, useNavigate } from "react-router-dom";
import styles from "./BookingSuccess.module.css";
import useAuthGuard from "../hooks/useAuthGuard";

const BookingSuccess = () => {
  useAuthGuard();
  const location = useLocation();
  const navigate = useNavigate();

  const message =
    location.state?.message || "Your booking has been successfully confirmed!";

  const handleNavigation = () => {
    navigate("/customer/dashboard/booking-list");
  };

  return (
    <div className={styles.container}>
      <h2>Booking Successful!</h2>
      <p className={styles.message}>{message}</p>
      <p className={styles.info}>
        You will pay in-store at pickup. Please visit the store to complete your
        transaction.
      </p>
      <button className={styles.backButton} onClick={handleNavigation}>
        Back to Dashboard
      </button>
    </div>
  );
};

export default BookingSuccess;
